<template>
    <WrongAppRedirect :user-types="userTypes" :redirect-url="redirectUrl" />
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { parseWrongAppQuery } from '../utils/authNavigation'
    import WrongAppRedirect from '../components/WrongAppRedirect.vue'

    const route = useRoute()

    const wrongAppState = computed<{ userTypes: import('../composables/useUserTypeCheck').UserType[]; redirectUrl: string }>(() => parseWrongAppQuery(route.query))
    const userTypes = computed<import('../composables/useUserTypeCheck').UserType[]>(() => wrongAppState.value.userTypes)
    const redirectUrl = computed<string>(() => wrongAppState.value.redirectUrl)
</script>
